// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__TixlA","productName":"Table_productName__2OObb"};